module.exports = __webpack_public_path__ + "static/1071-ec49d1fea549182032865f6f998a33b3.png";